import React from 'react';
import '../../../styles/global.css';
// import demoVideo from './game-demo.mov';

function CheeseToastGame() {
  return (
    <div className="body-container">
      <h1>Cheese Toast Maker Game</h1>
      <h4>Oct 2022</h4>
      <p>A cheese-toast making game made with p5.js. Play the game on itch.io! </p>
      <iframe src="https://itch.io/embed/1756583?border_width=0" width="550" height="165">
        <a href="https://mtang.itch.io/cheese-toast-maker">cheese toast maker by mtang</a>
      </iframe>
      <p>
        Check out the GitHub code <a href='https://github.com/tangmonica/cheese-toast-maker' target="_blank" rel="noopener noreferrer">here</a>!
      </p>
      <h3>
        Gameplay Demo:
      </h3>
      <video src={require('./game-demo.mov')} controls>
        <source src={require("./game-demo.mov")} type="video/mp4" />
      </video>
    </div>
  );
};

export default CheeseToastGame;
